import { render } from "./SocialTribe.vue?vue&type=template&id=13ab7183&ts=true"
import script from "./SocialTribe.vue?vue&type=script&lang=ts"
export * from "./SocialTribe.vue?vue&type=script&lang=ts"

import "./SocialTribe.vue?vue&type=style&index=0&id=13ab7183&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__